export const documentCategories = [
  { id: "all", label: "All Documents" },
  { id: "financial", label: "Financial" },
  { id: "legal", label: "Legal" },
  { id: "operational", label: "Operational" },
  { id: "it-technology", label: "IT & Technology" },
  { id: "environmental", label: "Environmental" },
  { id: "commercial", label: "Commercial" },
  { id: "hr-employment", label: "HR & Employment" },
  { id: "regulatory", label: "Regulatory" },
];
